// Base colors
const COLOR_BLUEBERRY = '#3858E9';

const COLOR_PURPLE_30 = '#A77EFF';

const COLOR_BLUE_30 = '#66BDFF';

export const COLOR_GRAY_100 = '#F0F0F0';

// Semantic colors
const COLOR_PRIMARY = COLOR_BLUEBERRY;
const COLOR_SECONDARY = COLOR_BLUE_30;

// Theme
export const WOO_COLORS = [ COLOR_PRIMARY, COLOR_SECONDARY, COLOR_PURPLE_30, '#7B90FF', '#EB6594' ];
